import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  tipo_apelacion_selected: {}, //seleccionara el objeto de la lista de magistrados
  tipos_apelaciones: []
};
export const mutations = {
  SELECT_TIPO_APELACION({ context }, tipo_apelacion) {
    return (state.tipo_apelacion_selected = Object.assign({}, tipo_apelacion));
  },
  FILL_TIPOS_APELACION({ context }, list_tipos) {
    let tipos = [];
    Object.entries(list_tipos).forEach(([key, val]) => tipos.push(val));
    return (state.tipos_apelaciones = tipos);
  }
};
export const actions = {
  GET_ALL_TIPOS_APELACION({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("CLEAR_NOTIFICATION");
          commit("FILL_TIPOS_APELACION", response.data.data.tipo_apelaciones);
          commit("SET_NOTIFICATION", {
            type: "success",
            message: response.data.message
          });
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  SAVE_TIPO_APELACION({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.post(data)
        .then(response => {
          commit("CLEAR_NOTIFICATION");
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  EDIT_TIPO_APELACION({ commit }, data) {
  return new Promise((resolve, reject) => {
    commit("SET_LOADING", true); //este loadin esta en el index principalde store
    ApiService.put(data)
      .then(response => {
        commit("CLEAR_NOTIFICATION");
        resolve(response);
      })
      .catch(error => {
        console.log(error);
        reject(error);
      });
  });
},
  DELETE_TIPO_APELACION({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.delete(data)
        .then(response => {
          commit("CLEAR_NOTIFICATION");
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
};
export const getters = {
  getAllTiposApelacion: state => {
    return state.tipos_apelaciones;
  }
};
